
import { Checkbox, Autocomplete, Backdrop, CircularProgress, BottomNavigation, BottomNavigationAction, Box, Snackbar, Button, Card, Typography, TextField, Grid, FormControlLabel, Switch, Select, FormControl, InputLabel, MenuItem, CardHeader, CardContent, Paper, InputAdornment, useMediaQuery, useTheme, Avatar, Badge } from '@mui/material';
import { useState, Fragment, useEffect, useRef } from 'react';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import DeleteIcon from '@mui/icons-material/Delete';

import OficialesFind from './OficialesFind';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios, { getServerBaseURL } from "../api/axios"

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCardIcon from '@mui/icons-material/AddCard';
import SearchIcon from '@mui/icons-material/Search';

import InversionistaFind from './InversionistaFind';

export default function Inversionista(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [id, setId] = useState(0);
    const [nombre, setNombre] = useState("")
    const [apellido, setApellido] = useState("")
    const [celular, setCelular] = useState("")
    const [email, setEmail] = useState("")
    const [direccion, setDireccion] = useState("")
    const [porciento, setPorciento] = useState(0)
    const [maximo, setMaximo] = useState(0)
    const [maximoReenganche, setMaximoReenganche] = useState("0")
    const [inactivo, setInactivo] = useState(false)
    const [puedeReinvertir, setPuedeReinvertir] = useState(false)
    const [puedeRetirar, setPuedeRetirar] = useState(true)
    const [caducada, setCaducada] = useState(false)
    const [cuenta, setCuenta] = useState("")
    const [cuentaBanco, setCuentaBanco] = useState(0)
    const [cuentaCxc, setCuentaCxc] = useState("")
    const [cuentaCxp, setCuentaCxp] = useState("")
    //const [oficial, setOficial] = useState(0)


    const [oficial, setOficial] = useState({ id: 0, label: '' });
    const [oficialInput, setOficialInput] = useState("")

    const [oficialComision, setOficialComision] = useState("0")
    const [gastosOperativos, setGastosOperativos] = useState("25")
    const [usuario, setUsuario] = useState("")
    const [clave, setClave] = useState("")
    const [repite, setRepite] = useState("")
    const [nivel, setNivel] = useState(2)
    const [showClave, setShowClave] = useState(false)
    const [showRepite, setShowRepite] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [procesando, setProcesando] = useState(false)
    const [rowsEmpresas, setRowsEmpresas] = useState([])
    const [empresas, setEmpresas] = useState([])
    const [rowsCuentas, setRowsCuentas] = useState([])

    const [openBusqueda, setOpenBusqueda] = useState(false)
    const [foto, setFoto] = useState(null)
    const [fotoPreview, setFotoPreview] = useState(null)
    const [fotoEliminada, setFotoEliminada] = useState(false)
    const fileInputRef = useRef(null)

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    useEffect(() => {
        let cual = props.cual || 0;
        inicio(cual)
        actRowsCompanias()
        actCatalogo()
    }, [])




    const handleClick = () => {
        if (puedeGrabar()) {
            grabar();
        }
    }

    const grabar = async () => {
        setProcesando(true)
        let empresas_seleccionadas = []
        for (var i = 0; i < empresas.length; i++) {
            let item = { id: empresas[i].id }
            empresas_seleccionadas.push(item)
        }
        let nOficial = oficial.id || 0

        try {
            const respuesta = await axios.post("inversionista/grabar", {
                cual: id,
                nombre: nombre,
                apellido: apellido,
                celular: celular,
                email: email,
                direccion: direccion,
                ciudad: 0,
                inactivo: (inactivo ? -1 : 0),
                porciento: porciento,
                oficial: nOficial,
                maximo: maximo,
                usuario: usuario,
                clave: clave,
                nivel: nivel,
                oficial_comision: oficialComision,
                gastos_operativos: gastosOperativos,
                maximo_reenganche: maximoReenganche,
                cuenta: cuenta,
                cuenta_banco: cuentaBanco,
                empresas: JSON.stringify(empresas_seleccionadas),
                caducada: (caducada ? -1 : 0),
                puede_reinvertir: (puedeReinvertir ? -1 : 0),
                puede_retirar: (puedeRetirar ? -1 : 0),
                cuenta_cxc: cuentaCxc,
                cuenta_cxp: cuentaCxp,
                // Enviar foto como base64 si existe una nueva, o "ELIMINAR" si se eliminó
                foto: foto ? fotoPreview : (fotoEliminada ? "ELIMINAR" : null)
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            let data = respuesta.data;
            if (data.respuesta == "S") {
                setMensaje("Datos grabados exitosamente")
                // Limpiar input de archivo
                if (fileInputRef.current) {
                    fileInputRef.current.value = ''
                }
                // Si estamos editando, recargar para ver la foto; si es nuevo, limpiar
                if (id > 0) {
                    await inicio(id, true)
                } else {
                    inicio(0)
                }
            } else {
                setMensaje(data.mensaje)
            }

        } catch (error) {
            setMensaje(error.message)
        }
        setProcesando(false)
    }

    const puedeGrabar = () => {
        let resultado = true;
        if (nombre.length == 0) { setMensaje("Debe digitar el Nombre"); return false; }
        if (usuario.length == 0) { setMensaje("Debe digitar el Usuario"); return false; }
        if (clave.length == 0) {
            setMensaje("Debe digitar la clave");
            return false;
        } else {
            if (repite.length == 0) {
                setMensaje("Debe confirmar la clave");
                return false;
            } else {
                if (clave !== repite) {
                    setMensaje("Claves no coinciden");
                    return false;
                }
            }
        }


        return resultado;
    }
    const handleCloseMensaje = () => {
        setMensaje("")
    }
    const actionMsg = (
        <Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseMensaje}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Fragment>
    );

    const handleClickBuscar = () => {
        setOpenBusqueda(true)
    }

    const handleCerrarBusqueda = () => {
        setOpenBusqueda(false)
    }

    const handleSeleccionBusqueda = (cual) => {
        inicio(cual)
        setOpenBusqueda(false)
    }

    const handleFotoClick = () => {
        fileInputRef.current?.click()
    }

    const handleFotoChange = (event) => {
        const file = event.target.files[0]
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setMensaje("La imagen no debe superar los 5MB")
                return
            }
            if (!file.type.startsWith('image/')) {
                setMensaje("Solo se permiten archivos de imagen")
                return
            }
            setFoto(file)
            setFotoEliminada(false)
            const reader = new FileReader()
            reader.onloadend = () => {
                setFotoPreview(reader.result)
            }
            reader.readAsDataURL(file)
        }
    }

    const handleEliminarFoto = () => {
        setFoto(null)
        setFotoPreview(null)
        setFotoEliminada(true)
        if (fileInputRef.current) {
            fileInputRef.current.value = ''
        }
    }

    const blanquea = () => {
        setId(0)
        setNombre("")
        setApellido("")
        setCelular("")
        setEmail("")
        setDireccion("")
        setPorciento(0)
        setMaximo(0)
        setOficial({ label: '', id: 0 })
        setOficialInput("")
        setInactivo(false)
        setCaducada(false)
        setUsuario("")
        setClave("")
        setEmpresas([])
        setRepite("")
        setNivel(2)
        setOficialComision("0")
        setGastosOperativos("25")
        setMaximoReenganche("0")
        setCuenta("")
        setCuentaBanco(0)
        setPuedeReinvertir(false)
        setPuedeRetirar(true)
        setCuentaCxc("")
        setCuentaCxp("")
        setFoto(null)
        setFotoPreview(null)
        setFotoEliminada(false)
        if (fileInputRef.current) {
            fileInputRef.current.value = ''
        }
    }

    const inicio = async (cual, esRecarga = false) => {
        // Solo limpiar campos si NO es una recarga después de guardar
        if (!esRecarga) {
            blanquea();
        }
        if (cual == 0) { return }

        setProcesando(true)
        try {
            const respuesta = await axios.post("inversionista/inicio", {
                cual: cual
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            console.log("iniicio", data)
            setId(cual)
            setNombre(data.nombre)
            setApellido(data.apellido)
            setCelular(data.celular)
            setEmail(data.email)
            setDireccion(data.direccion)
            setPorciento(data.porciento)
            setMaximo(data.maximo)
            setInactivo(data.inactivo !== 0 ? true : false)
            setCaducada(data.caducada !== 0 ? true : false)
            setPuedeReinvertir(data.puede_reinvertir !== 0 ? true : false)
            setPuedeRetirar(data.puede_retirar !== 0 ? true : false)
            setUsuario(data.usuario)
            setClave(data.clave)
            setRepite(data.clave)
            setNivel(data.nivel)
            setMaximoReenganche(data.maximo_reenganche)
            setOficialComision(data.oficial_comision)
            setGastosOperativos(data.gastos_operativos || "25")
            setOficial({ label: data.oficial_nombre, id: data.oficial })
            setOficialInput(data.oficial_nombre || "")
            setCuenta(data.cuenta)
            setCuentaBanco(data.cuenta_banco)
            setCuentaCxc(data.cuenta_cxc)
            setCuentaCxp(data.cuenta_cxp)

            setEmpresas(JSON.parse(data.empresas))

            // Cargar foto si existe (construir URL completa)
            if (data.foto_url) {
                setFotoPreview(`${getServerBaseURL()}${data.foto_url}`)
            } else {
                // Solo limpiar foto si no hay foto en el servidor
                setFotoPreview(null)
            }
            // Limpiar estados de foto nueva
            setFoto(null)
            setFotoEliminada(false)

        } catch (error) {

        }
        setProcesando(false)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const actRowsCompanias = async () => {
        let rows = []
        try {
            const respuesta = await axios.post("listas/companias", null, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;

            if (data.respuesta == "S") {
                let r = data.lista;
                for (var i = 0; i < r.length; i++) {
                    let item = { title: r[i].nombre, id: r[i].id }
                    rows.push(item)
                }
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {

        }
        setRowsEmpresas(rows)
    }

    const actCatalogo = async () => {
        let rows = []
        try {
            const respuesta = await axios.post("contabilidad/catalogo", null, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;

            if (data.respuesta == "S") {
                let r = data.lista;
                for (var i = 0; i < r.length; i++) {
                    let item = { nombre: r[i].nombre, id: r[i].numero }
                    rows.push(item)
                }
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {

        }
        setRowsCuentas(rows)
    }


    return (
        <Box sx={{
            minHeight: "100vh",
            backgroundColor: '#fafafb',
            p: isMobile ? 1 : 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: isMobile ? 'flex-start' : 'flex-start',
            pt: isMobile ? 1 : 3
        }}>
            {objWait()}
            {openBusqueda && <InversionistaFind open={openBusqueda} cerrar={handleCerrarBusqueda} seleccion={handleSeleccionBusqueda} />}
            <Snackbar
                open={mensaje.length == 0 ? false : true}
                autoHideDuration={6000}
                onClose={handleCloseMensaje}
                action={actionMsg}
                message={mensaje}
                sx={isMobile ? { bottom: 70 } : {}}
            />
            <Paper
                elevation={isMobile ? 6 : 3}
                sx={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : { sm: '100%', md: 520, lg: 650, xl: 750 },
                    minHeight: 'auto',
                    margin: 0,
                    borderRadius: isMobile ? '12px' : '8px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    boxShadow: isMobile ? '0 8px 32px rgba(30, 58, 95, 0.12)' : '0 4px 16px rgba(30, 58, 95, 0.1)',
                    border: '1px solid rgba(30, 58, 95, 0.1)',
                    p: 0,
                    overflow: 'auto'
                }}
            >

                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: isMobile ? '12px 12px 0 0' : '8px 8px 0 0',
                    borderBottom: isMobile ? '3px solid #d4af37' : '2px solid #d4af37',
                    py: isMobile ? 1.5 : 1,
                    px: isMobile ? 1.5 : 1.5
                }}>
                    <Typography
                        variant={isMobile ? 'h6' : 'subtitle1'}
                        sx={{ color: "white", textAlign: "center", fontWeight: 600, letterSpacing: 0.5 }}
                    >
                        Inversionistas
                    </Typography>
                </Box>
                <BottomNavigation
                    sx={{
                        mb: isMobile ? 1 : 0.5,
                        height: isMobile ? 56 : 44,
                        minHeight: isMobile ? 56 : 44,
                        '& .MuiBottomNavigationAction-root': {
                            minWidth: isMobile ? 'auto' : 60,
                            padding: isMobile ? '6px 12px' : '4px 8px 4px',
                            minHeight: isMobile ? 56 : 44,
                        },
                        '& .MuiBottomNavigationAction-label': {
                            fontSize: isMobile ? '0.75rem' : '0.65rem'
                        },
                        '& .MuiSvgIcon-root': {
                            fontSize: isMobile ? '1.5rem' : '1.2rem'
                        }
                    }}
                    showLabels
                    onChange={(event, newValue) => {
                        if (newValue === 0) { inicio(0) }
                        if (newValue === 1) { handleClick() }
                        if (newValue === 2) { handleClickBuscar() }
                    }}
                >
                    <BottomNavigationAction label="Nuevo" icon={<SaveAltIcon />} />
                    <BottomNavigationAction label="Grabar" icon={<AddCardIcon />} />
                    <BottomNavigationAction label="Buscar" icon={<SearchIcon />} />
                </BottomNavigation>

                <Box padding={isMobile ? 1.5 : 1.5}>
                    {/* Input oculto para seleccionar archivo */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFotoChange}
                        accept="image/*"
                        style={{ display: 'none' }}
                    />

                    {/* Sección de foto de perfil */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        mb: isMobile ? 2 : 1.5
                    }}>
                        <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={
                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                    <IconButton
                                        onClick={handleFotoClick}
                                        sx={{
                                            backgroundColor: '#1e3a5f',
                                            color: 'white',
                                            width: isMobile ? 28 : 24,
                                            height: isMobile ? 28 : 24,
                                            border: '2px solid white',
                                            '&:hover': {
                                                backgroundColor: '#2c5282'
                                            }
                                        }}
                                    >
                                        <CameraAltIcon sx={{ fontSize: isMobile ? 14 : 12 }} />
                                    </IconButton>
                                    {fotoPreview && (
                                        <IconButton
                                            onClick={handleEliminarFoto}
                                            sx={{
                                                backgroundColor: '#dc2626',
                                                color: 'white',
                                                width: isMobile ? 28 : 24,
                                                height: isMobile ? 28 : 24,
                                                border: '2px solid white',
                                                '&:hover': {
                                                    backgroundColor: '#b91c1c'
                                                }
                                            }}
                                        >
                                            <DeleteIcon sx={{ fontSize: isMobile ? 14 : 12 }} />
                                        </IconButton>
                                    )}
                                </Box>
                            }
                        >
                            <Avatar
                                src={fotoPreview}
                                sx={{
                                    width: isMobile ? 80 : 64,
                                    height: isMobile ? 80 : 64,
                                    border: isMobile ? '3px solid #d4af37' : '2px solid #d4af37',
                                    boxShadow: '0 4px 12px rgba(30, 58, 95, 0.2)',
                                    backgroundColor: '#e2e8f0',
                                    cursor: 'pointer',
                                    fontSize: isMobile ? '2rem' : '1.5rem',
                                    color: '#1e3a5f'
                                }}
                                onClick={handleFotoClick}
                            >
                                {!fotoPreview && nombre ? nombre.charAt(0).toUpperCase() : ''}
                            </Avatar>
                        </Badge>
                        <Typography
                            variant="caption"
                            sx={{
                                mt: 0.5,
                                color: '#64748b',
                                fontSize: isMobile ? '0.7rem' : '0.65rem'
                            }}
                        >
                            Toca para {fotoPreview ? 'cambiar' : 'agregar'} foto
                        </Typography>
                    </Box>

                    <Grid container spacing={isMobile ? 1.5 : 1}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Nombre"
                                value={nombre}
                                onChange={(event) => { setNombre(event.target.value.toUpperCase()) }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size="small"
                                value={apellido}
                                onChange={(event) => { setApellido(event.target.value.toUpperCase()) }}
                                label="Apellido"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                value={celular}
                                type='tel'
                                onChange={(event) => { setCelular(event.target.value.toUpperCase()) }}
                                label="Celular"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Email"
                                value={email}
                                type='email'
                                onChange={(event) => { setEmail(event.target.value.toUpperCase()) }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size="small"
                                value={direccion}
                                onChange={(event) => { setDireccion(event.target.value.toUpperCase()) }}
                                label="Dirección"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Porciento"
                                value={porciento}
                                onChange={(event) => { setPorciento(event.target.value) }}
                                type={"number"}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={6} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Máximo"
                                value={maximo}
                                onChange={(event) => { setMaximo(event.target.value) }}
                                type={"number"}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Max Reenganches"
                                value={maximoReenganche}
                                onChange={(event) => { setMaximoReenganche(event.target.value) }}
                                type={"number"}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormControlLabel
                                control={<Switch size="small" checked={inactivo} onChange={(event) => setInactivo(event.target.checked)} />}
                                label={<Typography sx={{ fontSize: isMobile ? '0.85rem' : '0.75rem' }}>Inactivo</Typography>}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <OficialesFind value={oficial} inputValue={oficialInput} handleCambio={(value) => { setOficial(value) }} handleCambioInput={(value) => { setOficialInput(value) }} />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Comisión"
                                value={oficialComision}
                                onChange={(event) => { setOficialComision(event.target.value) }}
                                type={"number"}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="% Gastos Op."
                                value={gastosOperativos}
                                onChange={(event) => { setGastosOperativos(event.target.value) }}
                                type={"number"}
                                variant="outlined"
                                helperText="Efectivo desde 24/12/2024"
                                FormHelperTextProps={{ sx: { fontSize: '0.6rem', m: 0 } }}
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormControlLabel
                                control={<Switch size="small" checked={puedeRetirar} onChange={(event) => setPuedeRetirar(event.target.checked)} />}
                                label={<Typography sx={{ fontSize: isMobile ? '0.75rem' : '0.7rem' }}>Puede retirar</Typography>}
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormControlLabel
                                control={<Switch size="small" checked={puedeReinvertir} onChange={(event) => setPuedeReinvertir(event.target.checked)} />}
                                label={<Typography sx={{ fontSize: isMobile ? '0.75rem' : '0.7rem' }}>Puede reinvertir</Typography>}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Cuenta Banco"
                                autoComplete='off'
                                value={cuenta}
                                onChange={(event) => { setCuenta(event.target.value.toUpperCase()) }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="label-banco">Banco:</InputLabel>
                                <Select
                                    labelId="labelbanco"
                                    id="cuentaBanco"
                                    label="Tipo Banco"
                                    value={cuentaBanco}
                                    onChange={(event) => { setCuentaBanco(event.target.value) }}
                                >
                                    <MenuItem value={0}>(Seleccione)</MenuItem>
                                    <MenuItem value={1}>BHD</MenuItem>
                                    <MenuItem value={2}>Reservas</MenuItem>
                                    <MenuItem value={5}>Popular</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <Autocomplete
                                multiple
                                size="small"
                                options={rowsEmpresas}
                                getOptionLabel={(option) => option.title}
                                value={empresas}
                                onChange={(event, newValue) => { setEmpresas(newValue) }}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                            size="small"
                                        />
                                        {option.title}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Compañías permitidas"
                                        placeholder="(Elija compañías)"
                                    />
                                )}
                            />
                        </Grid>

                    </Grid>
                    <Paper elevation={isMobile ? 2 : 1} sx={{ marginTop: isMobile ? "20px" : "12px" }}>
                        <Box textAlign={"center"} sx={{
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            borderRadius: '6px 6px 0 0',
                            borderBottom: isMobile ? '2px solid #d4af37' : '1px solid #d4af37',
                            py: isMobile ? 0.75 : 0.5
                        }}>
                            <Typography variant={isMobile ? 'subtitle1' : 'caption'} sx={{ color: '#d4af37', fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase' }}>
                                Datos Usuario
                            </Typography>
                        </Box>
                        <Grid container spacing={isMobile ? 1.5 : 1} padding={isMobile ? 1.5 : 1.5}>
                            <Grid item xs={8}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Usuario"
                                    value={usuario}
                                    onChange={(event) => { setUsuario(event.target.value) }}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <FormControlLabel
                                    control={<Switch size="small" checked={caducada} onChange={(event) => { setCaducada(event.target.checked) }} />}
                                    label={<Typography sx={{ fontSize: isMobile ? '0.8rem' : '0.7rem' }}>Caducada</Typography>}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Clave"
                                    type={showClave ? 'text' : 'password'}
                                    value={clave}
                                    onChange={(event) => { setClave(event.target.value) }}
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setShowClave(!showClave)}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    edge="end"
                                                    size="small"
                                                >
                                                    {showClave ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type={showRepite ? 'text' : 'password'}
                                    value={repite}
                                    onChange={(event) => { setRepite(event.target.value) }}
                                    label="Repita"
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setShowRepite(!showRepite)}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    edge="end"
                                                    size="small"
                                                >
                                                    {showRepite ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Nivel Usuario</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Nivel Usuario"
                                        value={nivel}
                                        onChange={(event) => { setNivel(event.target.value) }}
                                    >
                                        <MenuItem value={1}>Administrador</MenuItem>
                                        <MenuItem value={2}>Inversionista</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="cxc-label">Cuenta CxC</InputLabel>
                                    <Select
                                        labelId="cxc-label"
                                        label="Cuenta CxC"
                                        value={cuentaCxc}
                                        onChange={(event) => { setCuentaCxc(event.target.value) }}
                                    >
                                        <MenuItem value={""}>{"(Seleccione)"}</MenuItem>
                                        {
                                            rowsCuentas.map((row)=>{
                                                return (
                                                    <MenuItem key={row.id} value={row.id}>{row.nombre}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="cxp-label">Cuenta CxP</InputLabel>
                                    <Select
                                        labelId="cxp-label"
                                        label="Cuenta CxP"
                                        value={cuentaCxp}
                                        onChange={(event) => { setCuentaCxp(event.target.value) }}
                                    >
                                        <MenuItem value={""}>{"(Seleccione)"}</MenuItem>
                                        {
                                            rowsCuentas.map((row)=>{
                                                return (
                                                    <MenuItem key={row.id} value={row.id}>{row.nombre}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>
                </Box>


            </Paper>
        </Box>

    )
}